import React from "react";
import { Link } from "react-router-dom";
import OptimizedImage from "../../utils/OptimizedImage";

import "./style.css";
import { ourTeam } from "../../Dashboard/dashboard";

const Team = () => {
  return (
    <section className="team-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div
              className="site-heading text-center wow fadeInUp"
              data-wow-duration="1s"
              data-wow-delay="0.8s"
            >
              <h3 className="sub-title">TEAM MEMBERS</h3>
              <h2 className="section-title">Our Creative Minds</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="row justify-content-center">
            {[ourTeam[0],ourTeam[1],ourTeam[2]]?.map(ourTeam => {
                return (
                  <div key={ourTeam.id} className="col-md-4 col-sm-6">
                    <div className="single-team-box">
                      <div className="team-image">
                        <OptimizedImage src={ourTeam.profileImage} alt="team" />
                        <div className="team-meta">
                          <h4>{ourTeam.Name}</h4>
                          <p>{ourTeam.Position}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
              }
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="text-center mt-5">
              <Link to="/team" className="cta-btn btn-fill">
                Explore More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Team;
